import React, { useEffect, useState } from 'react';
import { privateFetch } from '../../../../utils/apiHelper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { DataView } from 'primereact/dataview';
import EventItem from './EventItem';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import EventDetail from './EventDetail';
import EventManager from './EventManager';
import { CONSTANT } from '../../../../utils/constants';
import { SelectButton } from 'primereact/selectbutton';
import styles from "../../../../components/Display/Wrapper.module.scss";

function EventPage({ isActive }) {
  const { accountContext } = useAccountContext();
  const { setActiveView, navigationContext } = useNavigationContext();
  const [eventList, setEventList] = useState([]);
  const [eventDetail, setEventDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [showpastEventList, setShowPastEventList] = useState(false);
  const [emptyPayload, setEmptyPayload] = useState(false);
  const [layout, setLayout] = useState('grid');

  useEffect(() => {
    fetchEventList();
  }, [showpastEventList]);

  const fetchEventList = async () => {
    await privateFetch(
      'GET',
      'solarys',
      `/cu/${accountContext.id}/event/?date=${showpastEventList && 'past'}`
    ).then((res) => {
      setEventList(res);
    });
  };

  useEffect(() => {
    fetchEventList();
  }, [navigationContext]);

  const fetchEventDetail = async () => {
    await privateFetch(
      'GET',
      'solarys',
      `/cu/${accountContext.id}/event/${navigationContext.activeEventId}/`
    ).then((res) => {
      if (res) setEventDetail(res);
    });
  };

  const handleClickEvent = (event) => {
    setActiveView("syevent", event, "activeEventId");
  };

  useEffect(() => {
    if (navigationContext.activeEventId) {
      fetchEventDetail();
    } else setEventDetail(undefined);
  }, [navigationContext]);

  const goBackEventAction = {
    onClick: handleClickEvent,
    label: 'Retour à la liste'
  };

  const handleOpenManager = () => {
    setPanelIsOpen(true);
    setEmptyPayload(false);
  };

  const newEventAction = {
    onClick: handleOpenManager,
    label: 'Ajouter un évènement',
    icon: 'pi-plus'
  };

  const createEvent = async (eventForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'solarys',
      `/cu/${accountContext.id}/event/`,
      "L'évènement a bien été ajouté",
      JSON.stringify(eventForm)
    ).then(() => {
      fetchEventList();
      setPanelIsOpen(false);
      setLoading(false);
      setEventDetail(undefined);
      setEmptyPayload(true);
    });
  };

  const updateEvent = async (eventForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'solarys',
      `/cu/${accountContext.id}/event/${eventDetail.id}/`,
      "L'évènement a bien été modifié",
      JSON.stringify(eventForm)
    ).then(() => {
      fetchEventList();
      setPanelIsOpen(false);
      fetchEventDetail(eventDetail.id);
      setLoading(false);
    });
  };

  const deleteEvent = async (event) => {
    await privateFetch(
      'DELETE',
      'solarys',
      `/cu/${accountContext.id}/event/${event.id}/`,
      "L'évènement a bien été supprimé"
    ).then(() => {
      fetchEventList();
      setEventDetail(undefined);
    });
  };
  const toggleLayout = () => {
    setLayout(layout === 'grid' ? 'list' : 'grid');
  };

  const changeLayoutAction = {
    onClick: toggleLayout,
    ariaLabel: "changer le mode d'affichage",
    icon: layout == "grid" ? "pi-list" : 'pi-th-large'
  };



  const eventFilters = (
    <div className={styles.filterList}>
      <SelectButton
        value={showpastEventList}
        onChange={(e) => setShowPastEventList(e.value)}
        options={CONSTANT.solarys.selectButtonOptions}
        className={styles.switchButton}
      />
    </div>
  );

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Événements"
        labelAction={handleClickEvent}
        actions={eventDetail ? [goBackEventAction] : [changeLayoutAction, newEventAction]}
        detail={eventDetail}>
        {eventDetail ? (
          <EventDetail
            event={eventDetail}
            handleUpdateEvent={handleOpenManager}
            handleDelete={deleteEvent}
          />
        ) : (
          <>
            {eventFilters}
            <div className={styles.pageContentContainer}>
              <div className={` ${layout === 'grid' ? styles.gridLayout : styles.listLayout}`}>
                {eventList.map((event, index) => (
                  <EventItem
                    layout={layout}
                    key={index}
                    event={event}
                    handleClickEvent={() => handleClickEvent(event)} />
                ))}
              </div>
            </div>
          </>
        )}
      </PageWrapper>
      <EventManager
        isOpen={panelIsOpen}
        event={eventDetail}
        onCreate={createEvent}
        onUpdate={updateEvent}
        loading={loading}
        emptyPayload={emptyPayload}
        setPanelIsOpen={setPanelIsOpen}
        setEventDetail={setEventDetail}
      />
    </div>
  );
}

export default EventPage;
